import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import {
	type FuturePortfolioPartialUpdateRequestDTO,
	type GoalFuturePortfolioResponseDTO,
	patchFuturePortfoliosIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type UpdateFuturePortfolioInput = {
	id: number;
	goalId: number;
	body: FuturePortfolioPartialUpdateRequestDTO;
};

export const useFuturePortfolioUpdateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<
		GoalFuturePortfolioResponseDTO,
		Error,
		UpdateFuturePortfolioInput
	>({
		mutationFn: processResponse(({ id, body }: UpdateFuturePortfolioInput) =>
			patchFuturePortfoliosIdV2(body, id),
		),
		onSuccess: (_data, { goalId }) =>
			queryClient.invalidateQueries({
				queryKey: GoalsKeys.detail(goalId),
			}),
	});
};
